<template>
  <Modal title="绘本兑换" v-model="visible">
    <Form ref="bookExchangeForm" class="form" :label-width="100"
          :model="param" :rules="bookExchangeRule">
      <Row>

        <Col :span="22">
          <Form-item label="请输入兑换码" prop="activity">
            <Input v-model.number="param.code"></Input>
          </Form-item>
        </Col>

      </Row>
    </Form>
    <div slot="footer">
      <Button type="text" size="large" @click="visible=false">取消</Button>
      <Button type="primary" size="large" :loading="loadingUpdate" @click="exchange">兑换</Button>
    </div>
  </Modal>
</template>
<script>
export default {
  name: 'BookExchangeModal',
  props: {
    value: {
      type: Boolean,
      default: false
    },
    uid: {
      type: Number
    },
    successCallback: {
      type: Function
    }
  },
  data () {
    return {
      visible: this.value,
      loadingUpdate: false,
      param: {
        code: '',
      },
      bookExchangeRule: {
        code: [
          {required: true, message: '请输入兑换码', trigger: 'blur'},
          {type: 'string', max: 100, message: '长度不要超过100个字符', trigger: 'blur'},
          {
            validator (rule, value, callback, source, options) {
              let errors = []
              if (value.length === 0) {
                errors.push('不能为空')
                callback(errors)
                return
              }
              callback(errors)
            }
          },
        ],
      }
    }
  },
  methods: {
    exchange () {
      let self = this
      self.loadingUpdate = true
      if (!self.param.code) {
        self.$Message.warning('兑换码不能为空!')
        self.loadingUpdate = false
      } else {
        self.param.uid = self.uid
        self.$http.post('/book/exchange', self.param).then(function (res) {
          self.loadingUpdate = false
          if (res) {
            self.visible = false
            self.$Message.success('兑换成功!')
            self.successCallback()
          }
        })
      }
    }
  },
  watch: {
    value(val) {
      this.visible = val
    },
    visible (val) {
      this.param = {
        code: ''
      }
      this.$emit('input', val)
    }
  }
}
</script>



// WEBPACK FOOTER //
// BookExchangeModal.vue?5264e9e6